// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","block":"block-QiwOv","passengers":"passengers-2rTrA","passengers_readonly":"passengers_readonly-15V7Z"};